/** @file useStyleNotes: the art brief's style notes of one puppet, kept in local storage. */
import { useEffect, useState } from 'react';
import { DEFAULT_STYLE_NOTES } from './defaultStyleNotes';

const keyOf = (puppetId: string | null): string => `pose3d.art.styleNotes.${puppetId ?? ''}`;

/** The saved notes; the default when none are saved or storage is not available. */
function load(puppetId: string | null): string {
  try {
    return window.localStorage.getItem(keyOf(puppetId)) ?? DEFAULT_STYLE_NOTES;
  } catch {
    return DEFAULT_STYLE_NOTES;
  }
}

/** `[notes, setNotes]`: the puppet's notes, reloaded when another puppet opens, saved on every change. */
export function useStyleNotes(puppetId: string | null): [string, (text: string) => void] {
  const [notes, setNotes] = useState(() => load(puppetId));
  useEffect(() => { setNotes(load(puppetId)); }, [puppetId]);
  const set = (text: string): void => {
    setNotes(text);
    try {
      window.localStorage.setItem(keyOf(puppetId), text);
    } catch {
      // Storage may be blocked (private window); the notes then last until the page closes.
    }
  };
  return [notes, set];
}
